import axios from "axios";

const baseUrl = 'https://nominatim.openstreetmap.org';

export async function getAddressByCoords(lat, lon){
  try{
    const response = await axios.get(
      baseUrl+`/reverse`, 
      {
        params: {
          format: 'jsonv2',
          lat,
          lon,
        }
      });
    return response.data;
  }
  catch (err){
    console.log(err);
    return '';
  }
}





